<template>
  <div>
    <rabbey-table-3
      ref="table"
      v-loading="loading"
      :data="items"
      :columns="columns"
      :actions="actions"
      paginateFromApi
      :paginationApi="{
        currentPage: currentPage,
        pageSize: pageSize,
        total: totalItems
      }"
      @update-page-size="handleChangePageSize"
      @update-current-page="handleChangeCurrentPage"
      @rtable-push-action="handleCommand"
    />

    <RequestForm ref="detail" append-to-body />
  </div>
</template>

<script>
import RabbeyTable3 from "@/components/RabbeyTable3.vue";
import ImagePerson from "@/components/functionals/ImagePerson.vue";
import DatetimeFormatter from "@/components/functionals/DatetimeFormatter.vue";
import RequestForm from "@/views/modules/technical_support/requests/RequestForm.vue";

export default {
  name: "TableSupports",
  props: ["clientCode"],
  components: {
    RabbeyTable3,
    RequestForm
  },
  data() {
    return {
      currentPage: 1,
      pageSize: 10,
      totalItems: 0,
      skip: 0,
      loading: false,
      items: [],
      actions: [
        {
          label: "Ver",
          command: "view",
          icon: "el-icon-view"
        }
      ],
      columns: [
        {
          prop: "Id",
          label: "NO",
          width: 80,
          sortable: true,
          fixed: true
        },
        {
          prop: "StatusDescription",
          label: "Estatus",
          minWidth: 100
        },
        {
          prop: "Comments",
          label: "Descripción",
          minWidth: 350
        },
        {
          prop: "ServiceRequestType.Description",
          label: "Solictud",
          sortable: true,
          formatter: (row) => {
            return row.ServiceRequestType
              ? row.ServiceRequestType.Description
              : "";
          },
          minWidth: 200
        },
        {
          prop: "Customer.CustomerService",
          label: "Servicio",
          formatter: ImagePerson,
          minWidth: 170
        },
        {
          prop: "AssignedTechnician.FullName",
          label: "Tecnico",
          minWidth: 250,
          formatter: ImagePerson
        },
        {
          prop: "RequestDate",
          label: "Creado",
          formatter: DatetimeFormatter,
          minWidth: 190
        },
        {
          prop: "DueDate",
          label: "Limite",
          formatter: DatetimeFormatter,
          minWidth: 190
        },
        {
          prop: "SLAHoursToRespond",
          label: "SLA",
          minWidth: 75,
          sortable: true,
          formatter: (row) => {
            return row.SLAHoursToRespond ? row.SLAHoursToRespond : "";
          }
        }
      ]
    };
  },
  created() {
    this.getItems();
  },
  methods: {
    getItems() {
      this.loading = true;
      this.items = [];
      this.$http
        .get("/api/serviceRequests", {
          timeout: 100000,
          params: {
            "criteria.customerCode": this.clientCode,
            "criteria.ClientCode": this.clientCode,
            "criteria.companyCode": this.currentCompany,
            "criteria.page": this.currentPage,
            "criteria.skip": this.skip,
            "criteria.limit": this.pageSize
          }
        })
        .then(({ data }) => {
          this.items = data.Items;
          this.currentPage = data.CurrentPage;
          this.totalItems = data.ItemCount;
        })
        .catch((error) => {
          this.$message.error("Error al consultar las interacciones");
          console.error(error);
          this.items = [];
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleChangePageSize(size) {
      this.pageSize = size;
      this.getItems();
    },
    handleChangeCurrentPage(page) {
      this.currentPage = page;
      this.getItems();
    },
    handleCommand(c) {
      if (c.command === "view") {
        this.$refs.detail.draw(c.row.Id);
      }
    }
  }
};
</script>

<style></style>
